const NBSP = '\u00A0';

export function formatNumberWithSpaces(num: number): string {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
}

export function formatPrice(num: number | string): string {
    return formatNumberWithSpaces(Number(num)) + `${NBSP}₽`;
}

export function hasPositivePrice(price: number | null | undefined): boolean {
    return price !== null && price !== undefined && Number(price) > 0;
}

export function declineWord(num: number, words: [string, string, string]): string {
    const cases = [2, 0, 1, 1, 1, 2];
    return words[
        num % 100 > 4 && num % 100 < 20
            ? 2
            : cases[Math.min(num % 10, 5)]
        ];
}